"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonChipInfo = void 0;
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../../../typography");
var HEADING = {
    '1': '5',
    '2': '6',
};
var BODY = {
    '1': '3',
    '2': '4',
};
var PersonChipInfo = function (_a) {
    var name = _a.name, jobTitle = _a.jobTitle, _b = _a.level, level = _b === void 0 ? '1' : _b;
    return (react_1.default.createElement("div", { "data-component-name": "PersonChipInfo" },
        react_1.default.createElement(typography_1.Heading, { level: HEADING[level] }, name),
        jobTitle && (react_1.default.createElement(typography_1.Body, { level: BODY[level], color: "GREY_70" }, jobTitle))));
};
exports.PersonChipInfo = PersonChipInfo;
exports.default = exports.PersonChipInfo;
